import React from "react";
import { useHistory } from "react-router-dom";
import FeatureCard from "./FeatureCard";

interface WatermarkTemplateCreateProps {
  isLoggedIn: boolean;
  setOpenSignIn: (value: boolean) => void;
}

const WatermarkTemplateCreate: React.FC<WatermarkTemplateCreateProps> = ({
  isLoggedIn,
  setOpenSignIn,
}) => {
  const history = useHistory();

  return (
    <FeatureCard
      color="blue"
      onClick={() => (isLoggedIn ? history.push("/addtemplate") : setOpenSignIn(true))}
      title="Create Template"
      description="Save your watermark settings as a reusable template."
      icon={
        // create_template.svg ships as a white-fill/blue-outline icon; recolor it to a solid
        // blue fill via CSS mask instead of rendering the file's own outlined look.
        <span className="template-icon-mask template-icon-mask--blue" />
      }
    />
  );
};

export default WatermarkTemplateCreate;
